import { render } from "./index.vue?vue&type=template&id=02ab43bc&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./index.vue?vue&type=style&index=0&id=02ab43bc&lang=scss&module=true"
cssModules["$style"] = style0
import "./index.vue?vue&type=style&index=1&id=02ab43bc&scoped=true&lang=css"

import exportComponent from "/Users/mymac/Documents/Digitala/Perki/newest-perki/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules],['__scopeId',"data-v-02ab43bc"]])

export default __exports__